<div class="container">
    <form [formGroup]="formulario">

        <div class="row pt-1">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Criação De</mat-label>
                    <input matInput id="txtCreateIniDt" #txtCreateIniDt maxlength="10" mask="d0/M0/0000"
                        formControlName="created_at_inicial">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtCreateIniDt.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Criação Até</mat-label>
                    <input matInput id="txtCreateFinDt" #txtCreateFinDt maxlength="10" mask="d0/M0/0000"
                        formControlName="created_at_final">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtCreateFinDt.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-3">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Safra</mat-label>
                    <!-- <input matInput name="safra" formControlName="safra" maxlength="8"
                         #txtSafra id="txtSafra" class="InputUnblockColor"> -->
                    <!--[matAutocomplete]="auto2"-->
                    <mat-select formControlName="safra" multiple>

                        <mat-option *ngFor="let item of filteredOptionsSafra | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>

                    </mat-select>
                    <!-- <mat-autocomplete #auto2="matAutocomplete">
                        <mat-option *ngFor="let item of filteredOptionsSafra | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>
                    </mat-autocomplete> -->
                    <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                    <!-- <mat-hint align="end">{{txtSafra.value.length}} / 8</mat-hint> -->
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Site Beneficiamento</mat-label>
                    <input matInput #txtSite maxlength="15" formControlName="site_beneficiamento"
                        [matAutocomplete]="auto" readonly class="InputBlockColor">
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let item of filteredOptionsSite | async" [value]="item.initials">
                            {{item.initials | uppercase}}
                        </mat-option>
                    </mat-autocomplete>
                    <i matSuffix class="{{iconDisableField}}"></i>
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                    <mat-hint align="end">{{txtSite.value?.length || 0}}/15</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <!-- <div class="row pt-1">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Data Apontamento</mat-label>
                    <input matInput id="txtData" #txtData maxlength="10" mask="d0/M0/0000"
                        formControlName="data_apontamento">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtData.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Hora Apontamento</mat-label>
                    <input matInput id="txtHora" #txtHora maxlength="5" mask="Hh:m0" formControlName="hora_apontamento">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}</mat-hint>
                    <mat-hint align="end">{{txtHora.value.length}} / 5</mat-hint>
                </mat-form-field>
            </div>
        </div> -->

        <div class="row pt-3">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Híbrido RNC/Linhagem</mat-label>
                    <mat-select formControlName="hibrido_rnc" multiple>
                        <input matInput type="text" class="form-control filterTxt"
                            placeholder="Pesquisar por..."
                            (keyup)="createFilterHibrido($event.target.value)">
                        <mat-option *ngFor="let item of listHibrido" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6" *ngIf="areaSelect.includes('Básica')">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Lote Ds / Cs</mat-label>
                    <input matInput id="txtLoteCs" #txtLoteCs maxlength="40" formControlName="lote_cs">
                    <mat-hint align="start" class="InputLabelDetailsColor">
                    </mat-hint>
                    <mat-hint align="end">{{txtLoteCs.value.length}} / 40</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6" *ngIf="!areaSelect.includes('Básica')">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Lote CS</mat-label>
                    <input matInput id="txtLoteCs" #txtLoteCs maxlength="40" formControlName="lote_cs">
                    <mat-hint align="start" class="InputLabelDetailsColor">
                    </mat-hint>
                    <mat-hint align="end">{{txtLoteCs.value.length}} / 40</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-1">
            <div class="col-lg col-md" *ngIf="!areaSelect.includes('Básica')">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Lote Tb</mat-label>
                    <input matInput id="txtLoteTb" #txtLoteTb maxlength="40" formControlName="lote_tb">
                    <mat-hint align="start" class="InputLabelDetailsColor">
                    </mat-hint>
                    <mat-hint align="end">{{txtLoteTb.value.length}} / 40</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg col-md">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Peneira</mat-label>
                    <!-- <input matInput #txtPeneira maxlength="10" formControlName="peneira" > -->
                    <!--[matAutocomplete]="auto3"-->
                    <mat-select formControlName="peneira" multiple>

                        <mat-option *ngFor="let item of filteredOptionsPeneira | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>

                    </mat-select>
                    <!-- <mat-autocomplete #auto3="matAutocomplete">
                        <mat-option *ngFor="let item of filteredOptionsPeneira | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>
                    </mat-autocomplete> -->
                    <!-- <mat-hint align="end">{{txtPeneira.value?.length || 0}}/10</mat-hint> -->
                </mat-form-field>
            </div>

        </div>

        <div class="row pt-3">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Usuário</mat-label>
                    <!-- <input matInput name="usuario" formControlName="usuario"  maxlength="80"
                        #txtUsuario id="txtUsuario"> -->
                    <!--[matAutocomplete]="auto5"-->
                    <mat-select formControlName="usuario" multiple>

                        <mat-option *ngFor="let item of filteredOptionsUsuario | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>

                    </mat-select>
                    <!-- <mat-autocomplete #auto5="matAutocomplete">
                        <mat-option *ngFor="let item of filteredOptionsUsuario | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>
                    </mat-autocomplete> -->
                    <!-- <mat-hint align="end">{{txtUsuario.value.length}} / 80</mat-hint> -->
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Status</mat-label>
                    <mat-select name="status" formControlName="is_incomplete" disableOptionCentering>
                        <mat-option *ngFor="let item of listStatus" [value]="item.value">
                            {{item.value ? 'INCOMPLETO ' : 'COMPLETO'}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

        </div>

        <div class="row pt-1">
            <div class="col-lg-12 col-md-12" *ngIf="areaSelect.includes('Básica')">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">N° de campo (Básica)
                    </mat-label>
                    <input matInput id="txtNumeroCampo" #txtNumeroCampo maxlength="20" currencyMask
                      [options]="{ thousands: '', decimal: '', precision: 0 }" formControlName="numero_campo"
                     >
                    <i matSuffix class="{{iconEnableField}}"></i>
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>

                  </mat-form-field>
            </div>

        </div>

        <div class="row pt-2">
            <div class="col-lg col-md text-right">
                <button mat-flat-button color="primary" matTooltip="Limpar" class="textoGeral mr-1"
                    (click)="clearFilter()"><i class="fa fa-paint-brush" aria-hidden="true"></i> Limpar</button>
                <button mat-flat-button color="primary" matTooltip="Pesquisar" class="textoGeral mr-1"
                    (click)="sendFilter()"><i class="fa fa-search" aria-hidden="true"></i> Pesquisar</button>
            </div>
        </div>
    </form>
</div>
